module.exports = __webpack_public_path__ + "static/media/layer-to-front.6beaeae9.svg";